<!--
  PasswdChangeDialog.vue
    Passwd Change Dialog Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <v-dialog
    v-model="mDialog"
    fullscreen
    hide-overlay
    transition="slide-x-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card dark color="primary" app class="hm-iphonex-notch">
        <v-btn icon color="primary" @click="onClickClose">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t("settings.passwd") }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text
       id="hm-pcd-container"
       class="hm-pcd-container"
      >
      <div class="hm-iphonex-notch">
        <div class="hm-pcd-fields">
        <v-form v-model="mFormValid">
          <v-text-field class="hm-pcd-textfield"
            label="古いパスワード"
            v-model="mOldPasswd"
            :rules="[mOldPasswdRules.required]"
            type="password"
            required
          ></v-text-field>
          <v-text-field class="hm-pcd-textfield"
            label="新しいパスワード"
            v-model="mNewPasswd"
            :rules="[mNewPasswdRules.required, mNewPasswdRules.counter, matchOldPasswd]"
            type="password"
            required
          ></v-text-field>
          <v-text-field class="hm-pcd-textfield"
            label="新しいパスワード(確認)"
            v-model="mNewPasswdRe"
            :rules="[mNewPasswdReRules.required, unmatchNewPasswd]"
            type="password"
            required
          ></v-text-field>

          <div class="hm-pcd-msg">
            <span v-html="mFailMsg"></span>
          </div>

          <div class="hm-pcd-btn">
            <v-btn color="primary" @click="onClickPasswdChange">{{ $t("settings.passwd") }}</v-btn>
          </div>
        </v-form>
        </div>
      </div>
      </v-card-text>
    </v-card>

    <errorinfo-dialog-error ref="errorInfoDialogError">
      <div slot="msg">予期せぬエラーが発生しました。<br>ログインし直してください</div>
    </errorinfo-dialog-error>
    <errorinfo-dialog-fail ref="errorInfoDialogFail">
      <div slot="msg">パスワードの変更に失敗しました。<br>再度実行してください</div>
    </errorinfo-dialog-fail>
    <errorinfo-dialog-badpw ref="errorInfoDialogBadpw">
      <div slot="msg">古いパスワードが間違っています。<br>再度実行してください</div>
    </errorinfo-dialog-badpw>
    <systeminfo-dialog ref="systemInfoDialog">
      <div slot="msg">パスワードを変更しました。</div>
    </systeminfo-dialog>
  </v-dialog>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import { isNullorUndefined } from '@/common'
import ErrorInfoDialog from '@/components/dialogs/ErrorInfoDialog'
import SystemInfoDialog from '@/components/dialogs/SystemInfoDialog'

export default {
  name: 'PasswdChangeDialog',
  data: () => ({
    mDialog: false,
    mFormValid: false,
    mOldPasswd: '',
    mOldPasswdRules: {
      required: v => !!v || '古いパスワードが未入力です',
    },
    mNewPasswd: '',
    mNewPasswdRules: {
      required: v => !!v || '新しいパスワードが未入力です',
      counter: v => (v.length >= 8 && v.length <= 16) || '新しいパスワードは8文字以上16文字以下で設定してください',
    },
    mNewPasswdRe: '',
    mNewPasswdReRules: {
      required: v => !!v || '新しいパスワード(確認)が未入力です',
    },
    mFailMsg: '',
  }),
  components: {
    'errorinfo-dialog-error': ErrorInfoDialog,
    'errorinfo-dialog-fail': ErrorInfoDialog,
    'errorinfo-dialog-badpw': ErrorInfoDialog,
    'systeminfo-dialog': SystemInfoDialog,
  },
  mounted: function () {
    this.$log.debug('# PasswdChangeDialog')
    this.$on('changePasswd', this.showDialog)
  },
  destroyed: function () {
    this.$log.debug('# PasswdChangeDialog.')
  },
  methods: {
    // -------------------------------------------------------------------------
    onClickClose: function () {
      this.$store.commit('setIsWhereaboutsPage', true)   // 行動予定一覧の更新を行う
      this.mDialog = false
      this.mOldPasswd = null
      this.mNewPasswd = ''
      this.mNewPasswdRe = ''
      this.mFailMsg = ''
      this.mFormValid = false
    },
    // -------------------------------------------------------------------------
    showDialog: function () {
      this.$store.commit('setIsWhereaboutsPage', false)   // 行動予定一覧の更新を行わない
      this.mDialog = true  // Show Dialog
      this.$nextTick(() => {
        // DOM生成完了後に実行
        document.getElementById('hm-pcd-container').scrollTop = 0
      })
      /*
      this.mOldPasswd = ''
      this.mNewPasswd = ''
      this.mNewPasswdRe = ''
      this.mFailMsg = ''
      */
      this.mFormValid = false
    },
    // -------------------------------------------------------------------------
    onClickPasswdChange: async function () {
      if (!this.mFormValid) {
        this.mFailMsg = '入力内容に誤りがあります'
        return
      }

      let loginUserId = this.$store.getters.loginUserId
      if (isNullorUndefined(loginUserId)) {
        this.$log.error('login id is null or undefined.')
        this.$refs.errorInfoDialogError.$emit('show')
        return
      }

      let result = await this.$store.dispatch(
        'aChangePassword',
        {
          oldpasswd: this.mOldPasswd,
          newpasswd: this.mNewPasswd,
        }
      )

      this.$log.debug('result : ' + JSON.stringify(result))
      if ((!result.error) && (!result.body.error)) {
        this.$refs.systemInfoDialog.$emit('show')
      }
      else {
        if (result.body.status === 'bad oldpasswd') {
          this.$refs.errorInfoDialogBadpw.$emit('show')
        }
        else {
          this.$refs.errorInfoDialogFail.$emit('show')
        }
      }
    },
  },
  computed: {
    // -------------------------------------------------------------------------
    matchOldPasswd: function () {
      if (this.mOldPasswd === this.mNewPasswd) {
        return '新しいパスワードは古いパスワードと異なるものを設定してください'
      }
      return true
    },
    // -------------------------------------------------------------------------
    unmatchNewPasswd: function () {
      if (this.mNewPasswd === this.mNewPasswdRe) {
        return true
      }
      return '新しいパスワードと新しいパスワード(確認)が一致しません'
    },
  }
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-pcd-container {
  margin-top: 56px;
}
@media screen and (min-width: 601px) {
  /* 幅601px～ */
  .hm-pcd-container {
    width: calc(100vw - 17px);
  }
}
.hm-pcd-fields {
  margin: 30px auto;
  padding: 20px;
  width: 400px;
  border: solid 2px #8b0000;
  /* @Todo なぜか下が丸くならない
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  */
}
@media screen and (max-width: 601px) {
  /* 幅601px～ */
  .hm-pcd-fields {
    width: 85%;
  }
}

.hm-pcd-textfield {
  margin: 25px auto;
}
.hm-pcd-btn {
  margin-top: 35px;
  text-align: center;
}

.hm-pcd-msg {
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/PasswdChangeDialog.vue